// extracted by mini-css-extract-plugin
module.exports = {"logo_div":"logo_logo_div__MNKWT"};